import React from "react";

const ByPhoneNumber = ({ errors, setErrors, setLoginState, formState,phone,OTP }) => {
  return (
    <>
      <div className="form-group mb-3">
        <label className="custom-label-style" htmlFor="text">
          Phone Number <span style={{ color: "red" }}>*</span>
        </label>
        <input
          className={
            errors?.phoneNumber ? "invalid form-control" : "form-control"
          }
          id="text"
          type="text"
          name="text"
          autoComplete="text"
          value={formState?.phoneNumber}
          disabled={phone}
          onChange={(e) => {
            setLoginState({
              ...formState,
              phoneNumber: e.target.value,
            });
            setErrors({
              ...errors,
              phoneNumber: OTP
                ? e.target.value
                  ? e.target.value.match(/^\d{10}$/)
                    ? ""
                    : "Invalid phone number"
                  : "Phone Number is Mandatory"
                : "",
            });
          }}
        />
        <p className="text-danger text-left font-size-xs">
          <small className="validation-errors d-block font-size-xs mt-1">
            {errors?.phoneNumber}
          </small>
        </p>
      </div>
    </>
  );
};

export default ByPhoneNumber;
